<template>
  <div>
    <h1>Edición de paquetes de siniestros para extranet</h1>

    <filter-sinisters @change="fetchSinisters"></filter-sinisters>

    <selected-sinisters-summary
      :previousDollarPrice="previousDollarPrice"
      :fetchedRelatedAffected="fetchedRelatedAffected"
      :items="selectedSinisters"
      :editMode="true"
      @save="submitPackage"
    ></selected-sinisters-summary>

    <table-actions
      :tableHeaders="headers"
      title="Siniestros para armado de paquetes"
      :tableData="sinisterList"
      :fetchedRelatedAffected="fetchedRelatedAffected"
      @selected="onSelected"
    ></table-actions>
  </div>
</template>

<script>
import ExtranetService from "../../services/extranet";
import TableActions from "./TableActions";
import FilterSinisters from "./FilterSinisters";
import SelectedSinistersSummary from "./SelectedSinistersSummary";

export default {
  name: "EditSinisterPackage",
  components: { TableActions, SelectedSinistersSummary, FilterSinisters },
  data() {
    return {
      id: this.$route.params.id,
      fetchedRelatedAffected: [],
      previousDollarPrice: null,
      headers: [
        { text: "Número de siniestro", value: "sinisterNumber" },
        { text: "Autopista", value: "highway" },
        { text: "Número de requisición", value: "requisitionNumber" },
        { text: "Folio", value: "folio" },
        { text: "Total", value: "total" },
        { text: "UUID", value: "uuid" },
        { text: "Seleccionar", value: "select" },
      ],
      sinisterList: [],
      selectedSinisters: [],
    };
  },
  mounted() {
    Promise.all([
      ExtranetService.fetchSinisters(),
      ExtranetService.fetchSinisterPackageById(this.$route.params.id),
    ])
      .then((response) => {
        this.previousDollarPrice = response[1].exchangePrice;
        const aux = [...response[1].relatedAffected];
        this.sinisterList = aux.concat(response[0]);
        return response[1];
      })
      .then((res) => {
        this.fetchedRelatedAffected = [...res.relatedAffected];
      });
  },
  methods: {
    onSelected(items) {
      this.selectedSinisters = items;
    },
    fetchSinisters(params) {
      ExtranetService.fetchSinisters(params).then((response) => {
        const aux = [...this.fetchedRelatedAffected];
        this.sinisterList = aux.concat(response);
      });
    },
    submitPackage(dolar) {
      if (this.selectedSinisters.length === 0) {
        this.$alertMessage({
          title: "Favor de seleccionar al menos un siniestro",
        });
      } else {
        const deletedAffected = this.fetchedRelatedAffected.filter(
          (a) => !this.selectedSinisters.some((s) => s.id === a.id)
        );
        const relatedAffected = this.selectedSinisters.filter(
          (s) => !deletedAffected.some((a) => a.id === s.id)
        );
        ExtranetService.updateSinisterPackage(
          this.id,
          relatedAffected,
          deletedAffected,
          dolar
        )
          .then((response) => {
            this.$successMessage({
              title: `Se actualizó el paquete con folio: ${response.folio}`,
            });
            this.$router.push({ name: "Seguimiento de paquetes" });
          })
          .catch(this.$fireErrorResponse);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card {
  z-index: unset;
}
</style>


// WEBPACK FOOTER //
// src/pages/extranet/EditSinisterPackages.vue